export const leftArrowSvg = ({ size = 26, color = "#4674A4" }) => (
    <svg
        width="8"
        height="12"
        viewBox="0 0 8 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M1.8646 7.00001L7.52533 12.818C7.71793 13.0159 7.71359 13.3325 7.51566 13.525C7.31773 13.7176 7.00119 13.7133 6.80866 13.5154L0.808661 7.34867C0.619795 7.15461 0.619795 6.84541 0.808661 6.65134L6.80866 0.484671C7.00119 0.286737 7.31773 0.282405 7.51566 0.475004C7.71359 0.667538 7.71793 0.984072 7.52533 1.182L1.8646 7.00001Z"
            fill="#222C36"
        />
    </svg>
);

export const rightArrowSvg = ({ size = 26, color = "#4674A4" }) => (
    <svg
        width="8"
        height="12"
        viewBox="0 0 8 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M6.1354 7.00001L0.474671 1.18202C0.282071 0.984103 0.286405 0.66755 0.484338 0.474983C0.682272 0.28241 0.998805 0.28675 1.19134 0.484663L7.19134 6.65134C7.38021 6.84541 7.38021 7.15461 7.19134 7.34868L1.19134 13.5153C0.998805 13.7133 0.682272 13.7176 0.484338 13.525C0.286405 13.3325 0.282071 13.0159 0.474671 12.818L6.1354 7.00001Z"
            fill="#222C36"
        />
    </svg>
);

export const calendarSvg = ({ size = 26, color = "#4674A4" }) => (
    <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M14.75 0C16.5449 0 18 1.45507 18 3.25V14.75C18 16.5449 16.5449 18 14.75 18H3.25C1.45507 18 0 16.5449 0 14.75V3.25C0 1.45507 1.45507 0 3.25 0H14.75ZM16.5 5.5H1.5V14.75C1.5 15.7165 2.2835 16.5 3.25 16.5H14.75C15.7165 16.5 16.5 15.7165 16.5 14.75V5.5ZM4.75 11.5C5.44036 11.5 6 12.0596 6 12.75C6 13.4404 5.44036 14 4.75 14C4.05964 14 3.5 13.4404 3.5 12.75C3.5 12.0596 4.05964 11.5 4.75 11.5ZM9 11.5C9.6904 11.5 10.25 12.0596 10.25 12.75C10.25 13.4404 9.6904 14 9 14C8.3096 14 7.75 13.4404 7.75 12.75C7.75 12.0596 8.3096 11.5 9 11.5ZM4.75 7.5C5.44036 7.5 6 8.0596 6 8.75C6 9.4404 5.44036 10 4.75 10C4.05964 10 3.5 9.4404 3.5 8.75C3.5 8.0596 4.05964 7.5 4.75 7.5ZM9 7.5C9.6904 7.5 10.25 8.0596 10.25 8.75C10.25 9.4404 9.6904 10 9 10C8.3096 10 7.75 9.4404 7.75 8.75C7.75 8.0596 8.3096 7.5 9 7.5ZM13.25 7.5C13.9404 7.5 14.5 8.0596 14.5 8.75C14.5 9.4404 13.9404 10 13.25 10C12.5596 10 12 9.4404 12 8.75C12 8.0596 12.5596 7.5 13.25 7.5ZM14.75 1.5H3.25C2.2835 1.5 1.5 2.2835 1.5 3.25V4H16.5V3.25C16.5 2.2835 15.7165 1.5 14.75 1.5Z"
            fill="#546463"
        />
    </svg>
);

export const searchSvg = ({ size = 26, color = "#4674A4" }) => (
    <svg
        className="me-2"
        width="16"
        height="16"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M1.5 7C1.5 3.96243 3.96243 1.5 7 1.5C10.0376 1.5 12.5 3.96243 12.5 7C12.5 10.0376 10.0376 12.5 7 12.5C3.96243 12.5 1.5 10.0376 1.5 7ZM7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C8.6628 14 10.1902 13.4202 11.3911 12.4518L16.7197 17.7803C17.0126 18.0732 17.4874 18.0732 17.7803 17.7803C18.0732 17.4874 18.0732 17.0126 17.7803 16.7197L12.4518 11.3911C13.4202 10.1902 14 8.6628 14 7C14 3.13401 10.866 0 7 0Z"
            fill="white"
        />
    </svg>
);

export const akhilLogoSvg = () => {
    return (
        <svg
            width="36"
            height="30"
            viewBox="0 0 36 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M22.2374 9.51644L16.8688 0L0 30H14.5797C15.9695 27.7369 15.8877 23.0658 16.6508 18.3075C17.4138 13.5493 20.4388 10.735 22.2374 9.51644Z"
                fill="#005DBD"
            />
            <path
                d="M23.6002 11.6924C21.8288 12.8239 19.6214 14.9419 18.8856 19.2649C18.1226 23.5879 18.5041 27.8239 17.1143 29.8839L35.9997 29.9129L23.6002 11.6924Z"
                fill="#D7D6D6"
            />
        </svg>
    );
};

export const helpIconSvg = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10 0C15.5228 0 20 4.47648 20 9.99851C20 15.5205 15.5228 19.997 10 19.997C8.3596 19.997 6.77516 19.601 5.35578 18.8555L1.06538 19.9723C0.6111 20.0907 0.1469 19.8183 0.02858 19.3641C-0.00801005 19.2237 -0.00802009 19.0763 0.0285499 18.9358L1.1449 14.648C0.3972 13.2274 0 11.6411 0 9.99851C0 4.47648 4.47715 0 10 0ZM10 13.498C9.4477 13.498 9 13.9456 9 14.4978C9 15.0501 9.4477 15.4977 10 15.4977C10.5523 15.4977 11 15.0501 11 14.4978C11 13.9456 10.5523 13.498 10 13.498ZM10 4.74929C8.4812 4.74929 7.25 5.98033 7.25 7.49888C7.25 7.91303 7.58579 8.24877 8 8.24877C8.3797 8.24877 8.6935 7.96666 8.7432 7.60064L8.7565 7.37109C8.8205 6.74087 9.3528 6.24907 10 6.24907C10.6904 6.24907 11.25 6.80863 11.25 7.49888C11.25 8.0376 11.115 8.30406 10.6051 8.83089L10.3011 9.14004C9.5475 9.92452 9.25 10.4876 9.25 11.4983C9.25 11.9124 9.5858 12.2482 10 12.2482C10.4142 12.2482 10.75 11.9124 10.75 11.4983C10.75 10.9596 10.885 10.6931 11.3949 10.1663L11.6989 9.85713C12.4525 9.07265 12.75 8.50953 12.75 7.49888C12.75 5.98033 11.5188 4.74929 10 4.74929Z"
                fill="#D2D4D5"
            />
        </svg>
    );
};

export const phoneIconSvg = ({ bgColor = "#38414A", color }) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="20" height="20" rx="10" fill={bgColor} />
            <path
                d="M7.35023 5.21949L7.96543 5.04749C8.54189 4.88631 9.15778 5.14679 9.40469 5.65616L9.89595 6.66984C10.1101 7.11156 9.99127 7.63102 9.60224 7.95408L8.51979 8.85308C8.58658 9.3908 8.79315 9.9203 9.13949 10.4416C9.48589 10.9629 9.91847 11.3953 10.4373 11.7388L11.7374 11.3595C12.2302 11.2157 12.7669 11.3809 13.0691 11.7695L13.7733 12.6748C14.1247 13.1265 14.0615 13.7497 13.6255 14.1327L13.1582 14.5431C12.6931 14.9517 12.0289 15.0999 11.4143 14.9322C9.96355 14.5362 8.62967 13.3606 7.41265 11.4054C6.19387 9.44725 5.76373 7.78595 6.12222 6.42145C6.27308 5.84728 6.74023 5.39004 7.35023 5.21949Z"
                fill={color}
            />
        </svg>
    );
};

export const editSvg = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.9519 1.0481C17.5543 -0.349421 15.2885 -0.349361 13.8911 1.04825L1.94103 12.9997C1.5347 13.4061 1.2491 13.9172 1.116 14.4762L0.0204088 19.0777C-0.0399112 19.3311 0.0355188 19.5976 0.219679 19.7817C0.403849 19.9659 0.670369 20.0413 0.923729 19.981L5.52498 18.8855C6.08418 18.7523 6.59546 18.4666 7.00191 18.0601L18.952 6.10861C20.3493 4.71112 20.3493 2.4455 18.9519 1.0481ZM14.9518 2.10884C15.7634 1.29709 17.0795 1.29705 17.8912 2.10876C18.7028 2.9204 18.7029 4.23632 17.8913 5.04801L17 5.93946L14.0606 3.00012L14.9518 2.10884ZM13 4.06084L15.9394 7.00018L5.94119 16.9995C5.73104 17.2097 5.46668 17.3574 5.17755 17.4263L1.76191 18.2395L2.57521 14.8237C2.64402 14.5346 2.79168 14.2704 3.00175 14.0603L13 4.06084Z" fill="#222C36" />
        </svg>
    )
}

export const clockSvg = () => {
    return (
        <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.99935 5.45866C8.99935 5.11348 8.71951 4.83366 8.37435 4.83366C8.02918 4.83366 7.74935 5.11348 7.74935 5.45866V9.62533C7.74935 9.97049 8.02918 10.2503 8.37435 10.2503H11.291C11.6362 10.2503 11.916 9.97049 11.916 9.62533C11.916 9.28016 11.6362 9.00033 11.291 9.00033H8.99935V5.45866ZM1.89625 6.58651C1.14636 5.97593 0.666016 5.04446 0.666016 4.00033C0.666016 2.15938 2.1584 0.666992 3.99935 0.666992C5.0435 0.666992 5.97487 1.14726 6.58552 1.89723C7.34302 1.63989 8.15485 1.50033 8.99935 1.50033C9.84385 1.50033 10.6558 1.6399 11.4133 1.89724C12.0238 1.14728 12.9553 0.666992 13.9994 0.666992C15.8403 0.666992 17.3328 2.15938 17.3328 4.00033C17.3328 5.04449 16.8524 5.97593 16.1024 6.58654C16.3598 7.34399 16.4993 8.15583 16.4993 9.00033C16.4993 10.8464 15.8323 12.5367 14.7263 13.8433L16.3163 15.4334C16.5603 15.6775 16.5603 16.0732 16.3163 16.3172C16.0722 16.5613 15.6765 16.5613 15.4324 16.3172L13.8423 14.7272C12.5357 15.8333 10.8454 16.5003 8.99935 16.5003C7.15328 16.5003 5.463 15.8333 4.15632 14.7272L2.56629 16.3172C2.32222 16.5613 1.92648 16.5613 1.68241 16.3172C1.43833 16.0732 1.43833 15.6775 1.68241 15.4334L3.27244 13.8433C2.16632 12.5367 1.49935 10.8464 1.49935 9.00033C1.49935 8.15583 1.63892 7.34399 1.89625 6.58651ZM1.91602 4.00033C1.91602 4.52615 2.11065 5.00683 2.43279 5.37389C3.11626 4.13894 4.13797 3.11723 5.37292 2.43377C5.00588 2.11167 4.52515 1.91699 3.99935 1.91699C2.84876 1.91699 1.91602 2.84973 1.91602 4.00033ZM15.5659 5.37393C15.8881 5.00688 16.0828 4.52616 16.0828 4.00033C16.0828 2.84973 15.15 1.91699 13.9994 1.91699C13.4736 1.91699 12.9928 2.11167 12.6258 2.43379C13.8608 3.11727 14.8825 4.13898 15.5659 5.37393ZM2.74935 9.00033C2.74935 12.4521 5.54757 15.2503 8.99935 15.2503C12.4511 15.2503 15.2493 12.4521 15.2493 9.00033C15.2493 5.54854 12.4511 2.75033 8.99935 2.75033C5.54757 2.75033 2.74935 5.54854 2.74935 9.00033Z" fill="#212121" />
        </svg>
    )
}

export const verifiedSvg = () => {
    return (
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.83585 1.03398C8.94837 1.07226 9.0583 1.11779 9.1649 1.17028L10.4477 1.80183C10.7958 1.97323 11.2038 1.97323 11.5519 1.80183L12.8347 1.17028C14.1972 0.499418 15.8457 1.06018 16.5165 2.42276L16.59 2.58509L16.6528 2.75183L17.1133 4.10543C17.2383 4.4728 17.5268 4.7613 17.8941 4.88627L19.2477 5.34673C20.6856 5.83585 21.4547 7.39799 20.9656 8.83585C20.9273 8.94837 20.8818 9.0583 20.8293 9.1649L20.1977 10.4477C20.0263 10.7958 20.0263 11.2038 20.1977 11.5519L20.8293 12.8347C21.5002 14.1972 20.9394 15.8457 19.5768 16.5165C19.4702 16.569 19.3603 16.6146 19.2477 16.6528L17.8941 17.1133C17.5268 17.2383 17.2383 17.5268 17.1133 17.8941L16.6528 19.2477C16.1637 20.6856 14.6016 21.4547 13.1637 20.9656C13.0512 20.9273 12.9413 20.8818 12.8347 20.8293L11.5519 20.1977C11.2038 20.0263 10.7958 20.0263 10.4477 20.1977L9.1649 20.8293C7.80233 21.5002 6.15389 20.9394 5.48303 19.5768C5.43053 19.4702 5.385 19.3603 5.34673 19.2477L4.88627 17.8941C4.7613 17.5268 4.4728 17.2383 4.10543 17.1133L2.75183 16.6528C1.31396 16.1637 0.544858 14.6016 1.03398 13.1637C1.07226 13.0512 1.11779 12.9413 1.17028 12.8347L1.80183 11.5519C1.97323 11.2038 1.97323 10.7958 1.80183 10.4477L1.17028 9.1649C0.499418 7.80233 1.06018 6.15389 2.42276 5.48303C2.52939 5.43053 2.63931 5.385 2.75183 5.34673L4.10543 4.88627C4.4728 4.7613 4.7613 4.4728 4.88627 4.10543L5.34673 2.75183C5.83585 1.31396 7.39799 0.544858 8.83585 1.03398ZM14.4695 7.96946L9.0502 13.3887L7.07595 11.0197C6.81078 10.7014 6.33786 10.6584 6.01965 10.9236C5.70144 11.1888 5.65845 11.6617 5.92362 11.9799L8.42362 14.9799C8.70596 15.3187 9.2183 15.342 9.5301 15.0301L15.5301 9.0301C15.823 8.73722 15.823 8.26235 15.5301 7.96946C15.2372 7.67657 14.7624 7.67657 14.4695 7.96946Z" fill="#22CE29" />
        </svg>
    )
}

export const succesBtnSvg = () => {
    return (
        <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M27.0006 0.333008C41.7281 0.333008 53.6673 12.2721 53.6673 26.9997C53.6673 41.7271 41.7281 53.6663 27.0006 53.6663C12.2731 53.6663 0.333984 41.7271 0.333984 26.9997C0.333984 12.2721 12.2731 0.333008 27.0006 0.333008ZM35.5865 18.9188L23.6673 30.8378L18.4149 25.5855C17.6338 24.8045 16.3675 24.8045 15.5864 25.5855C14.8054 26.3666 14.8054 27.6327 15.5864 28.4138L22.2532 35.0805C23.0342 35.8615 24.3004 35.8615 25.0814 35.0805L38.4148 21.7471C39.1959 20.9662 39.1959 19.6998 38.4148 18.9188C37.6337 18.1378 36.3676 18.1378 35.5865 18.9188Z" fill="#12AD8D" />
        </svg>

    )
}

export const closeSvg = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.39705 0.553791L0.46967 0.46967C0.73594 0.2034 1.1526 0.1792 1.44621 0.39705L1.53033 0.46967L8 6.939L14.4697 0.46967C14.7626 0.17678 15.2374 0.17678 15.5303 0.46967C15.8232 0.76256 15.8232 1.23744 15.5303 1.53033L9.061 8L15.5303 14.4697C15.7966 14.7359 15.8208 15.1526 15.6029 15.4462L15.5303 15.5303C15.2641 15.7966 14.8474 15.8208 14.5538 15.6029L14.4697 15.5303L8 9.061L1.53033 15.5303C1.23744 15.8232 0.76256 15.8232 0.46967 15.5303C0.17678 15.2374 0.17678 14.7626 0.46967 14.4697L6.939 8L0.46967 1.53033C0.2034 1.26406 0.1792 0.847401 0.39705 0.553791Z" fill="white" />
        </svg>
    )
}

export const ellipse1Svg = () => {
    return (
        <svg width="212" height="324" viewBox="0 0 212 324" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g opacity="0.1" filter="url(#filter0_f_138_8127)">
                <circle cx="5.66398" cy="116.968" r="107.611" fill="#005DBD" />
            </g>
            <defs>
                <filter id="filter0_f_138_8127" x="-200.447" y="-89.1431" width="412.223" height="412.222" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feGaussianBlur stdDeviation="49.25" result="effect1_foregroundBlur_138_8127" />
                </filter>
            </defs>
        </svg>
    )
}

export const ellipse2Svg = () => {
    return (
        <svg width="231" height="368" viewBox="0 0 231 368" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g opacity="0.1" filter="url(#filter0_f_138_8126)">
                <circle cx="206.129" cy="206.214" r="107.611" fill="#005DBD" />
            </g>
            <defs>
                <filter id="filter0_f_138_8126" x="0.0175781" y="0.102295" width="412.223" height="412.222" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feGaussianBlur stdDeviation="49.25" result="effect1_foregroundBlur_138_8126" />
                </filter>
            </defs>
        </svg>
    )
}

export const ellipse3Svg = () => {
    return (
        <svg width="291" height="166" viewBox="0 0 291 166" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g opacity="0.1" filter="url(#filter0_f_138_8128)">
                <circle cx="73.6289" cy="217.465" r="118.446" fill="#D8F2F2" />
            </g>
            <defs>
                <filter id="filter0_f_138_8128" x="-143.317" y="0.518921" width="433.893" height="433.892" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feGaussianBlur stdDeviation="49.25" result="effect1_foregroundBlur_138_8128" />
                </filter>
            </defs>
        </svg>

    )
}